import { Button, message, Tooltip } from 'antd';
import React, { useState } from 'react';
import { useToggle } from 'react-use';
import { fetchAPI } from '../utils/api';

const XeroSyncButton = ({ id, xero_invoice_id, endpoint }) => {
  const [loading, toggleLoading] = useToggle(false);
  const [xeroInvoiceId, setXeroInvoiceId] = useState(xero_invoice_id);

  const sync = async order_id => {
    toggleLoading();
    try {
      const { xero_invoice_id, error } = await fetchAPI(endpoint, {
        method: 'POST',
        payload: {
          item_id: order_id,
          check_status: false,
        },
      });
      if (error) {
        message.error(error);
      }
      if (!xero_invoice_id) {
        throw Error('Failed to sync to Xero');
      }
      setXeroInvoiceId(xero_invoice_id);
      message.success('Synced');
    } catch (e) {
      message.error('Failed to sync to Xero');
    } finally {
      toggleLoading();
    }
  };

  if (xeroInvoiceId) {
    return (
      <Tooltip title={'ID: ' + xeroInvoiceId}>
        <span>In Sync</span>
      </Tooltip>
    );
  }
  return (
    <Button type="primary" loading={loading} onClick={() => sync(id)}>
      Sync
    </Button>
  );
};

export default XeroSyncButton;
